import React, { useState, useContext } from "react";
import { useNavigate } from "react-router";
import { AuthContext } from "../context/auth-context";
import { useDispatch } from "react-redux";
import { Divider, Popover, Typography } from "@mui/material";
import Sidebar from "../Component/Sidebar/Sidebar";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import LogoutIcon from "@mui/icons-material/Logout";
const Layout = ({ children }) => {
  const { clearSession } = useContext(AuthContext);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const authCtx = useContext(AuthContext);
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const handleClickpop = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogOut = () => {
    window.location.reload(true);
    clearSession();
    dispatch({ type: "LOGOUT" });
    navigate("/login");
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <main>
      <div className="sidepanel d-flex flex-column flex-shrink-0 bg-light">
        <div style={{ borderBottom: "0.5px solid #B7C3CD", height: "70px" }}>
          <a
            href="#"
            className="p-3 d-flex align-items-center link-dark text-decoration-none"
            style={{ cursor: "pointer", marginLeft: "18px", height: "100%" }}
          >
            <img
              // src={require("../assets/images/logo.png")}
              src={"/revere-menu.webp"}
              width={150}
              height={150}
              style={{ objectFit: "contain", marginLeft: "-30px" }}
              alt="Brand-Luminaire"
            />

          </a>
        </div>
        <Sidebar />
      </div>
      <div className="main-content">
        <header>
          <div className="d-flex align-items-center justify-content-end mt-2">
            {/* <span className="me-4">
              <i className="feather icon-headphones"></i>
            </span>
            <span className="me-4">
              <i className="feather icon-bell"></i>
            </span> */}
            <div className="me-4">
              <div
                aria-describedby={id}
                onClick={handleClickpop}
                style={{ color: "#000", cursor: "pointer" }}
              >
                <i
                  alt=""
                  className="feather icon-user"
                  onClick={() => setDropdownOpen(!isDropdownOpen)}
                  id="profileImage"
                  style={{ cursor: "pointer" }}
                />
                <ArrowDropDownIcon />
              </div>
              <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
              >
                <div style={{ padding: "10px" }}>
                  <Typography
                    sx={{
                      color: "#555",
                    }}
                    variant="string"
                  >
                    Hello,{" "}
                    <span
                      style={{
                        color: "#007bff",
                        fontWeight: "bold",
                      }}
                    >
                      {authCtx?.user?.email}
                    </span>
                  </Typography>
                  <Divider
                    className="mt-2"
                    sx={{ bgcolor: "secondary.light" }}
                  />
                  <div className="py-2 d-flex flex-row justify-content-start align-items-center">
                    <LogoutIcon
                      fontSize="small"
                      sx={{ color: "#555", marginRight: 1 }}
                    />
                    <Typography
                      style={{ cursor: "pointer" }}
                      onClick={handleLogOut}
                    >
                      Sign Out
                    </Typography>
                  </div>
                </div>
              </Popover>
            </div>
          </div>
        </header>
        {children}
      </div>
    </main>
  );
};

export default Layout;
